// @flow
import { boolean, string } from 'yup';
import {
  CLUSTER_LINKING_WORKLOADS_INPUTS_DISPLAY_NAMES,
  CLUSTER_LINKING_WORKLOADS_INPUTS_FIELDNAMES,
} from '@streaming-projects/orgs/enums';
import { convertConfigArrayToMap, createFormNameToFieldsMap } from '@src/configuration/utils';
import { clusterMonthlyDataInputTransformationFunc } from '@components/cluster/cluster-input-table/utils';
import { FORM_NAMES } from '@streaming-projects/enums';

export const CLUSTER_LINKING_WORKLOAD_DETAILS_CONFIG = [
  {
    displayName: CLUSTER_LINKING_WORKLOADS_INPUTS_DISPLAY_NAMES.WORKLOAD_NAME,
    backendFieldName: CLUSTER_LINKING_WORKLOADS_INPUTS_FIELDNAMES.WORKLOAD_NAME,
    validation: string()
      .label(CLUSTER_LINKING_WORKLOADS_INPUTS_DISPLAY_NAMES.WORKLOAD_NAME)
      .required(),
    belongingForm: FORM_NAMES.CLUSTER_LINKING.WORKLOAD_DETAILS_FORM,
  },
  {
    displayName: CLUSTER_LINKING_WORKLOADS_INPUTS_DISPLAY_NAMES.IS_ENABLED,
    backendFieldName: CLUSTER_LINKING_WORKLOADS_INPUTS_FIELDNAMES.IS_ENABLED,
    validation: boolean()
      .label(CLUSTER_LINKING_WORKLOADS_INPUTS_DISPLAY_NAMES.IS_ENABLED)
      .required(),
  },
  {
    displayName: CLUSTER_LINKING_WORKLOADS_INPUTS_DISPLAY_NAMES.MONTHLY_INPUTS,
    backendFieldName: CLUSTER_LINKING_WORKLOADS_INPUTS_FIELDNAMES.MONTHLY_INPUTS,
    inputTransformationFunc: clusterMonthlyDataInputTransformationFunc,
    belongingForm: FORM_NAMES.CLUSTER_LINKING.WORKLOAD_MONTHLY_USAGE_FORM,
  },
];

export const CLUSTER_LINKING_WORKLOAD_DETAILS_CONFIG_MAP = convertConfigArrayToMap(
  CLUSTER_LINKING_WORKLOAD_DETAILS_CONFIG
);

export const CLUSTER_LINKING_WORKLOAD_DETAILS_FORM_NAMES_TO_FIELDS_MAP = createFormNameToFieldsMap(
  CLUSTER_LINKING_WORKLOAD_DETAILS_CONFIG
);
